import React, { useState, useEffect } from 'react';
import './SupportTokens.css';
import Table from '../../../../components/Table/Table';
import Button from '../../../../components/Button/Button';

const SupportTokens = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [supportData, setSupportData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    // Mock data - replace with API call in production
    const mockData = [
      {
        id: 1,
        supportFolio: 'Support Folio 1',
        requester: 'User name',
        group: 'Name group',
        email: 'Correo@gmail.com',
        requestDate: '11/10/1997',
        reason: 'Reason',
        status: 'Active'
      },
      {
        id: 2,
        supportFolio: 'Support Folio 2',
        requester: 'User name',
        group: 'Name group',
        email: 'Correo@gmail.com',
        requestDate: '11/10/1997',
        reason: 'Reason',
        status: 'Active'
      },
      {
        id: 3,
        supportFolio: 'Support Folio 3',
        requester: 'User name',
        group: 'Name group',
        email: 'Correo@gmail.com',
        requestDate: '11/10/1997',
        reason: 'Reason',
        status: 'Active'
      }
    ];

    setSupportData(mockData);
    setTotalItems(mockData.length);
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Here you would fetch data for the new page
  };

  const columns = [
    {
      header: 'Support Folio',
      field: 'supportFolio',
      render: (row) => <span>{row.supportFolio}</span>
    },
    {
      header: 'Who requested it?',
      field: 'requester',
      render: (row) => <span>{row.requester}</span>
    },
    {
      header: 'Group',
      field: 'group',
      render: (row) => <span>{row.group}</span>
    },
    {
      header: 'E-mail',
      field: 'email',
      render: (row) => <span>{row.email}</span>
    },
    {
      header: 'Date of request',
      field: 'requestDate',
      render: (row) => <span>{row.requestDate}</span>
    },
    {
      header: 'Reason',
      field: 'reason',
      render: (row) => <span>{row.reason}</span>
    },
    {
      header: 'Status',
      field: 'status',
      render: (row) => <span className="status-active">{row.status}</span>
    },
    {
      header: '',
      field: 'actions',
      render: (row) => (
        <div className="action-icons">
          <button className="action-button view-button">
            <i className="fas fa-eye"></i>
          </button>
        </div>
      )
    },
    {
      header: '',
      field: 'actions2',
      render: (row) => (
        <div className="action-icons">
          <button className="action-button download-button">
            <i className="fas fa-download"></i>
          </button>
        </div>
      )
    },
    {
      header: '',
      field: 'actions3',
      render: (row) => (
        <Button
          variant="primary"
          size="small"
          onClick={() => console.log('Check clicked for row', row.id)}
        >
          Check
        </Button>
      )
    }
  ];

  return (
    <div className="support-tokens-container">
      <h1 className="support-title">
        <span className="support-text">Support</span> Barter Bucks
      </h1>
      <div className="support-table">
        <Table
          columns={columns}
          data={supportData}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
          columnsShare={3}
          headerBackground="var(--color-primary)"
          headerTextColor="var(--color-white)"
        />
      </div>
    </div>
  );
};

export default SupportTokens;